export default __webpack_public_path__ + "static/media/LandlineSound.0f723bd9.mp3";